var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"national-m-sub"},[_c('img',{staticClass:"main-logo",attrs:{"src":require('../../assets/img/horizontal-black-scroll-icon.png'),"alt":"메인로고"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"m-sub-content"},[_c('span',{staticClass:"black"},[_vm._v("좌우로 스크롤")]),_vm._v("하여 확인해보세요.")])
}]

export { render, staticRenderFns }